import React from 'react';

const MapSelection = ({ onClick }) => {
  return (
    <div 
      className="esri-widget--button esri-widget esri-interactive" 
      title="Select Wells by Rectangle"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        cursor: 'pointer'
      }}
    >
      <span className="esri-icon-checkbox-unchecked" style={{ fontSize: '18px' }}></span>
    </div>
  );
};

export default MapSelection;